<div class="modal-header">
    <h4 class="modal-title">{{ title }}</h4>
</div>
<form name="form" #form="ngForm">
    <div class="modal-body">
        <div class="row">
            <div class="col-md-12 form-group">
                <label for="pl-job">Job</label>
                <input type="text" class="form-control" id="pl-job" [value]="parentPage.selectedJobName" readonly />
            </div>
        </div>
        <div class="row">
            <div class="col-md-3 form-group">
                <label for="pl-item">Item #</label>
                <input type="number" class="form-control" [(ngModel)]="target.item" name="pl-item" id="pl-item" [disabled]="!parentPage.canEdit" />
            </div>
            <div class="col-md-4 form-group">
                <label for="pl-priority">Priority</label>
                <input type="number" class="form-control" [(ngModel)]="target.priority" name="pl-priority" id="pl-priority" [disabled]="!parentPage.canEdit" />
            </div>
            <div class="col-md-5 form-group">
                <label for="pl-pm">Project Mate #</label>
                <input type="text" class="form-control" [(ngModel)]="target.projectMateNumber" name="pl-pm" id="pl-pm" [disabled]="!parentPage.canEdit" />
            </div>
        </div>
        <div class="row">
            <div class="col-md-6 form-group">
                <label for="pl-location">Location</label>
                <input type="text" class="form-control" [(ngModel)]="target.location" name="pl-location" id="pl-location" [disabled]="!parentPage.canEdit" />
            </div>
            <div class="col-md-6 form-group">
                <label for="pl-scope">Scope</label>
                <input type="text" class="form-control" [(ngModel)]="target.scope" name="pl-scope" id="pl-scope" [disabled]="!parentPage.canEdit" />
            </div>
        </div>
        <div class="row">
            <div class="col-md-12 form-group">
                <label for="pl-desc">Description</label>
                <textarea class="form-control" [(ngModel)]="target.description" name="pl-desc" id="pl-desc" rows="2" [disabled]="!parentPage.canEdit"></textarea>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12 form-group">
                <label for="pl-vancon-user">VanCon Responsible</label>
                @if (parentPage.canEdit) {
                    <wj-combo-box
                        [(ngModel)]="target.vanConResponsibleUserId"
                        name="pl-vancon-user"
                        id="pl-vancon-user"
                        [itemsSource]="vanConUserOptions"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                    ></wj-combo-box>
                } @else {
                    <input type="text" class="form-control" id="pl-vancon-user" [value]="vanConResponsibleDisplay" readonly />
                }
            </div>
        </div>
        <div class="row">
            <div [ngClass]="showTradeContact ? 'col-md-5' : 'col-md-10'" class="form-group">
                <label for="pl-firm">Optional: Non-VanCon Firm Responsible</label>
                @if (parentPage.canEdit) {
                    <wj-combo-box
                        [(ngModel)]="target.responsibleFirmId"
                        (ngModelChange)="onResponsibleChange()"
                        name="pl-firm"
                        id="pl-firm"
                        [itemsSource]="firmOptions"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                    ></wj-combo-box>
                } @else {
                    <input type="text" class="form-control" id="pl-firm" [value]="firmResponsibleDisplay" readonly />
                }
            </div>
            <div class="col-md-5 form-group" *ngIf="showTradeContact">
                <label for="pl-contact">Contact</label>
                @if (parentPage.canEdit) {
                    <wj-combo-box
                        [(ngModel)]="target.contactId"
                        name="pl-contact"
                        id="pl-contact"
                        [itemsSource]="contactOptions"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                    ></wj-combo-box>
                } @else {
                    <input type="text" class="form-control" id="pl-contact" [value]="contactDisplay" readonly />
                }
            </div>
            <div class="col-md-2 form-group">
                <label for="pl-done">Done</label>
                <wj-combo-box
                    [(ngModel)]="target.done"
                    name="pl-done"
                    id="pl-done"
                    [itemsSource]="boolMap"
                    [displayMemberPath]="'display'"
                    [selectedValuePath]="'value'"
                ></wj-combo-box>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12 form-group">
                <label for="pl-notes">Notes</label>
                <textarea class="form-control" [(ngModel)]="target.notes" name="pl-notes" id="pl-notes" rows="2" [disabled]="!parentPage.canEdit"></textarea>
            </div>
        </div>
        @if (target.completionComment) {
            <div class="row">
                <div class="col-md-12 form-group">
                    <label>Completion Comment (from recipient)</label>
                    <textarea class="form-control" rows="2" readonly>{{ target.completionComment }}</textarea>
                </div>
            </div>
        }
        @if (target.imageUrls && target.imageUrls.length > 0) {
            <div class="row">
                <label>Images/Files</label>
                @for (url of target.imageUrls; let i = $index; track i + '|' + url) {
                    <div class="col-sm-6 col-6" style="margin-bottom: 10px">
                        @if (isVideo(url)) {
                            <video style="max-width: 250px; cursor: pointer" [src]="getExistingFileSrc(url)" (click)="openImage(url)" muted preload="metadata"></video>
                            <div class="small text-muted mt-1">{{ displayFileName(i) }}</div>
                        } @else if (isPdf(url)) {
                            <img class="attachment-pdf-thumb" style="cursor: pointer" src="./Resources/pdfImage.png" (click)="openImage(url)" alt="" />
                            <div class="small text-muted mt-1">{{ displayFileName(i) }}</div>
                        } @else {
                            <img style="max-width: 250px; cursor: pointer" [src]="getExistingImageSrc(url)" (click)="openImage(url)" />
                            <div class="small text-muted mt-1">{{ displayFileName(i) }}</div>
                        }
                    </div>
                }
            </div>
        }
        @if (images && images.length > 0) {
            <div class="row">
                <label>Photos To Upload</label>
                @for (image of images; track image) {
                    <div class="col-sm-6 col-6" style="max-width: 324px; margin-bottom: 10px">
                        <div class="close-x" (click)="removeImage(image)">
                            <fa-icon [icon]="faX"></fa-icon>
                        </div>
                        @if (image.type === 'application/pdf') {
                            <img class="attachment-pdf-thumb" [src]="getPendingImageSrc(image)" alt="" />
                        } @else {
                            <img style="max-width: 300px" [src]="getPendingImageSrc(image)" alt="" />
                        }
                    </div>
                }
            </div>
        }
        @if (videos && videos.length > 0) {
            <div class="row">
                <label>Videos To Upload</label>
                @for (video of videos; track video) {
                    <div class="col-12" style="margin-bottom: 5px">
                        <div class="close-x" style="display: inline-block; margin-right: 8px; cursor: pointer" (click)="removeVideo(video)">
                            <fa-icon [icon]="faX"></fa-icon>
                        </div>
                        <span>{{ video.name }}</span>
                    </div>
                }
            </div>
        }
        @if (documents && documents.length > 0) {
            <div class="row">
                <label>Documents To Upload</label>
                @for (doc of documents; track doc) {
                    <div class="col-12" style="margin-bottom: 5px">
                        <div
                            class="close-x"
                            style="display: inline-block; margin-right: 8px; cursor: pointer"
                            (click)="removeDocument(doc)"
                        >
                            <fa-icon [icon]="faX"></fa-icon>
                        </div>
                        <span>{{ doc.name }}</span>
                    </div>
                }
            </div>
        }
        @if (progress > 0 && progress < 100) {
            <div class="row">
                <div class="col-12">
                    <div class="progress">
                        <div
                            class="progress-bar"
                            role="progressbar"
                            [ngStyle]="{ 'width.%': progress }"
                            [attr.aria-valuenow]="progress"
                            aria-valuemin="0"
                            aria-valuemax="100"
                        >
                            {{ progress }}%
                        </div>
                    </div>
                </div>
            </div>
        }
    </div>
    <div class="modal-footer">
        @if (parentPage.canEdit) {
        <div style="margin-right: auto">
            <button type="button" class="btn btn-success me-1" (click)="photoInput.click()">Photo</button>
            <input style="display: none" type="file" (change)="onPhotoChanged($event)" accept="image/*" #photoInput multiple />
            <button type="button" class="btn btn-success me-1" (click)="videoInput.click()">Video</button>
            <input style="display: none" type="file" (change)="onVideoChanged($event)" accept="video/*" #videoInput />
            <button type="button" class="btn btn-success" (click)="docInput.click()">Document</button>
            <input
                style="display: none"
                type="file"
                (change)="onDocumentChanged($event)"
                accept=".pdf,.doc,.docx,.xls,.xlsx,.txt"
                #docInput
                multiple
            />
        </div>
        }
        <button id="btnSave" type="submit" class="btn btn-primary" (click)="save()" [disabled]="form.invalid || isSaving">
            @if (isSaving) {
                <span>Saving…</span>
            } @else {
                <span>Save</span>
            }
        </button>
        <button id="btnCancel" type="button" class="btn btn-secondary" (click)="cancel()" [disabled]="isSaving">Cancel</button>
    </div>
</form>
